var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 2.66699V6.66699",
    stroke: "url(#paint0_linear_432_3237)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 2.66699V6.66699",
    stroke: "url(#paint1_linear_432_3237)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 12.1201H27.3327",
    stroke: "url(#paint2_linear_432_3237)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11.3337V22.667C28 26.667 26 29.3337 21.3333 29.3337H10.6667C6 29.3337 4 26.667 4 22.667V11.3337C4 7.33366 6 4.66699 10.6667 4.66699H21.3333C26 4.66699 28 7.33366 28 11.3337Z",
    stroke: "url(#paint3_linear_432_3237)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9269 18.2663H20.9389",
    stroke: "url(#paint4_linear_432_3237)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9269 22.2663H20.9389",
    stroke: "url(#paint5_linear_432_3237)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9941 18.2666H16.0061",
    stroke: "url(#paint6_linear_432_3237)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9933 22.2663H16.0053",
    stroke: "url(#paint7_linear_432_3237)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0597 18.2663H11.0717",
    stroke: "url(#paint8_linear_432_3237)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0597 22.2663H11.0717",
    stroke: "url(#paint9_linear_432_3237)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_432_3237",
    x1: 11.166,
    y1: 2.66699,
    x2: 11.166,
    y2: 6.66699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_432_3237",
    x1: 21.834,
    y1: 2.66699,
    x2: 21.834,
    y2: 6.66699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_432_3237",
    x1: 15.9993,
    y1: 12.1201,
    x2: 15.9993,
    y2: 13.1201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_432_3237",
    x1: 16,
    y1: 4.66699,
    x2: 16,
    y2: 29.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_432_3237",
    x1: 20.9329,
    y1: 17.5996,
    x2: 20.9329,
    y2: 18.9329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_432_3237",
    x1: 20.9329,
    y1: 21.5996,
    x2: 20.9329,
    y2: 22.9329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_432_3237",
    x1: 16.0001,
    y1: 18.2666,
    x2: 16.0001,
    y2: 19.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_432_3237",
    x1: 15.9993,
    y1: 21.5996,
    x2: 15.9993,
    y2: 22.9329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_432_3237",
    x1: 11.0657,
    y1: 17.5996,
    x2: 11.0657,
    y2: 18.9329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_432_3237",
    x1: 11.0657,
    y1: 21.5996,
    x2: 11.0657,
    y2: 22.9329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/IconCalendar.85207c497ea77a9650fcee1d22ea666e.svg";
export { ForwardRef as ReactComponent };